import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";
import { S25ToggleButtonModule } from "../../../modules/s25-toggle-button/s25.toggle.button.module";

@Component({
    selector: "s25-ng-event-copy-options",
    standalone: true,
    imports: [S25ToggleButtonModule],
    template: `
        <p class="copy-event-section__title">Copy options</p>
        <div class="c-margin-bottom--quarter">
            Select <strong>Related</strong> to create a copy related to this event or a related event set; otherwise,
            select <strong>Stand-Alone</strong> to create an independent copy.
        </div>
        @if (hasRelationships()) {
            <div class="c-margin-bottom--quarter">
                Additionally, select <strong>Related</strong> and choose from the following events to create a new set.
            </div>
        }
        <s25-toggle-button
            class="c-margin-top--half"
            [value]="isStandAlone()"
            [trueLabel]="'Stand-Alone'"
            [falseLabel]="'Related'"
            (valueChange)="isStandAlone.set($event)"
        />
    `,
    host: {
        class: "copy-event-section",
    },
    styleUrls: ["./event.copy.options.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventCopyOptionsComponent {
    readonly isStandAlone = model<boolean | undefined>();
    readonly hasRelationships = input(false);
}
